import React from "react";
import { useParams, useSearchParams } from "react-router-dom";
import UnityWebViewer from "../components/UnityWebViewer";


const EmbedPage = () => {
  const { experienceId } = useParams();
  const [searchParams] = useSearchParams();

  const userData = {
    name: searchParams.get("userName"),
    id: searchParams.get("userId"),
    organizationId: searchParams.get("organizationId"),
    subscriptionStatus: searchParams.get("subscriptionStatus"),
  };

  return (
    <div className="App">
      <UnityWebViewer experienceId={experienceId} userData={userData} embed />
    </div>
  );
};

export default EmbedPage;
